import { MoneyField as GammaMoneyField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type MoneyFieldProps = React.ComponentProps<typeof GammaMoneyField>

type Props = Omit<MoneyFieldProps, 'selectValue' | 'missingLabel' | 'locale'> & {
  missingLabel?: string
}

const MoneyField = ({ missingLabel, ...props }: Props) => (
  <GammaMoneyField
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    locale={i18n.locale}
  />
)

export default MoneyField
